"use client";

import { useSearchParams, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import { JOBS } from "../../../data/jobs";
import Link from "next/link";
import { FILTER_OPTIONS } from "../../../utils/constants";

const CurrentJobs = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [jobs, setJobs] = useState([]);
  const searchTerm = searchParams.get("search") || "";
  const category = searchParams.get("job__category_spec") || "";
  const [search, setSearch] = useState(searchTerm);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isSearchEdited, setIsSearchEdited] = useState(false);
  const type = searchParams.get("job__type_spec") || "";
  const location = searchParams.get("job__location_spec") || "";
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const normalizeString = (str) => {
    return str
      .trim()
      .replace(/[^a-zA-Z0-9\s]/g, " ")
      .toLowerCase();
  };

  //function to update URL
  const updateURL = (key, value) => {
    const params = new URLSearchParams(searchParams.toString());
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
    router.push(`?${params.toString()}`, { scroll: false });
  };

  //===={filter jobs}====
  const filterJobs = JOBS.filter((job) => {
    const isSearchProvided = searchTerm.trim() !== "";
    const isCategoryProvided = category !== "";
    const isTypeProvided = type !== "";
    const isLocationProvided = location !== "";

    if (
      !isSearchProvided &&
      !isCategoryProvided &&
      !isTypeProvided &&
      !isLocationProvided
    ) {
      return true;
    }

    const matchSearchTerm =
      !isSearchProvided ||
      job.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchCategory =
      !isCategoryProvided ||
      normalizeString(job.category) === normalizeString(category);

    const matchType =
      !isTypeProvided || normalizeString(job.type) === normalizeString(type);
    const matchLocation =
      !isLocationProvided ||
      normalizeString(job.location) === normalizeString(location);

    return matchSearchTerm && matchCategory && matchType && matchLocation;
  });

  const handleSearch = () => {
    if (isSearchActive && !isSearchEdited) {
      setIsSearchActive(false);
      setSearch("");
      updateURL("search", "");
      setIsSearchEdited(false);
    } else {
      updateURL("search", search.trim());
      setIsSearchActive(true);
      setIsSearchEdited(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setIsSearchEdited(true);
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible);
  };


  // 


  const fetchJobs = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();

      if (searchTerm) params.append("q", searchTerm);
      if (category) params.append("category", category);
      if (type) params.append("type", type);
      if (location) params.append("location", location);

      const response = await fetch(
        `/api/job?${params.toString()}`
      );
      if(response.ok){
        const data = await response.json();
        setJobs(data?.result || []);
      }else{
        throw new Error("Failed to fetch jobs");
      }
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [searchTerm, category, type, location]);

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  
  // 
  return (
    <div>
      <div className="top flex ">
        <div className="left-filter ">
          {/* ===Search=== */}
          <div className="search flex">
            <input
              type="text"
              placeholder="Search Jobs..."
              value={search}
              onChange={handleSearchChange}
              onKeyDown={handleSearchKeyDown}
            ></input>

            <div className="svg flex center-center" onClick={handleSearch}>
              {isSearchActive && !isSearchEdited ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              )}
            </div>
          </div>
          <div
            className="icon-filter center-center  b-r-5"
            onClick={handleFilterClick}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 1024 1024"
              fill="black"
              xmlns="http://www.w3.org/2000/svg"
              style={{ verticalAlign: "middle", overflow: "hidden" }}
            >
              <path d="M640 288a64 64 0 1 1 0.032-128.032A64 64 0 0 1 640 288z m123.456-96c-14.304-55.04-64-96-123.456-96s-109.152 40.96-123.456 96H128v64h388.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896V192h-132.544zM640 864a64 64 0 1 1 0.032-128.032A64 64 0 0 1 640 864m0-192c-59.456 0-109.152 40.96-123.456 96H128v64h388.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896v-64h-132.544c-14.304-55.04-64-96-123.456-96M384 576a64 64 0 1 1 0.032-128.032A64 64 0 0 1 384 576m0-192c-59.456 0-109.152 40.96-123.456 96H128v64h132.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896v-64H507.456c-14.304-55.04-64-96-123.456-96" />
            </svg>
          </div>
        </div>
        {/* ===category=== */}
        <div className={`filter ${isFilterVisible ? "show-filter" : ""}`}>
          {FILTER_OPTIONS.map(({ key, label, item, options }) => (
            <div key={key} className={key.split("__")[1].replace("_spec", "")}>
              <select
                value={eval(item)}
                onChange={(e) => updateURL(key, e.target.value)}
              >
                <option value="">{label}</option>
                {options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt.charAt(0).toUpperCase() +
                      opt.slice(1).replace(/-/g, " ")}
                  </option>
                ))}
              </select>
            </div>
          ))}
        </div>
      </div>

      {/* <==JOBS==> */}
      <div className="bottom flex">
         {loading ? (
          <div style={{width:"100%"}} className="flex center-center"><p className="t-a-c">Loading jobs...</p></div>
        ) : jobs?.length > 0 ? (
          jobs?.map((i, index) => (
            <div className="content " key={index}>
                <Link href={`/jobs/${i.Id}`}>
                  <h2 className="color-black font-nunito-sans l-h-1-2 f-w-500">
                    {i.Name}
                  </h2>

                  <p>{i.Category}</p>
                  <p>{i.JobType}</p>
                  <p>{i.Location}</p>
                  <div
                    className="flex"
                    style={{
                      gap: "2px",
                    }}
                  >
                    <span className="color-dark-blue font-nunito-sans f-w-700 p-16">
                      More Details{" "}
                    </span>
                    <div className="flex center-center">
                      <svg
                        className="color-dark-blue"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14" />
                        <path d="M12 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                </Link>
            </div> 
          ))
        ) : (
          <div style={{width:"100%"}} className="flex center-center"><p className="t-a-c">Sorry! No jobs to show.</p></div>
        )}

      </div>
    </div>
  );
};

export default CurrentJobs;
